import { Select } from 'antd';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

interface IAdminStatCard {
  title: string;
  value: string | number;
  duration?: string;
  change?: number;
  increase?: number;
  decrease?: number;
}

const AdminStatCard = (props: IAdminStatCard) => {
  const { t } = useTranslation(['analysisAndReports']);
  const { title, value, duration, change, increase, decrease } = props;

  const showChange = duration && (increase || decrease);

  return (
    <div className="flex w-full flex-col gap-2 rounded-lg border-[1px] border-border-color bg-white px-8 py-4">
      <h3 className="text-[#4B5563]">{title}</h3>
      <p className="text-2xl font-bold text-headings-font-color">{value}</p>
      {showChange ? (
        <div className="flex flex-row gap-5">
          {increase ? (
            <span className="text-primary-green">
              + {increase} {t('thisMonth')}
            </span>
          ) : null}
          {decrease ? (
            <span className="text-primary-red">
              -{'  '}
              {Math.abs(decrease)} {t('thisMonth')}
            </span>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

export default AdminStatCard;
